export default "__VITE_ASSET__CyV6J8iX__"